module.exports = __webpack_public_path__ + "img/gb9121_6_a.prt.3c883bf7.jpg";